import { render, staticRenderFns } from "./ChatterProjectDetail.vue?vue&type=template&id=1ce067dd"
import script from "./ChatterProjectDetail.vue?vue&type=script&lang=js"
export * from "./ChatterProjectDetail.vue?vue&type=script&lang=js"
import style0 from "./ChatterProjectDetail.vue?vue&type=style&index=0&id=1ce067dd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports